export default class DownloadUtils {
    baixarBlob(data, nomeArquivo, tipoBlob){
        let blob = new Blob([data], {
            type: tipoBlob
        })
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = nomeArquivo
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }
}
